/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Search_Status_Not_EmbeddedInputs */



/**
* | output |
* | --- |
* | "Not Embedded" |
*
* @param {Spaces_Search_Status_Not_EmbeddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_search_status_not_embedded = /** @type {((inputs?: Spaces_Search_Status_Not_EmbeddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Search_Status_Not_EmbeddedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht eingebettet")
	return /** @type {LocalizedString} */ ("Not Embedded")
});